import { ArrowRight, Calculator, Newspaper } from "lucide-react";
import { Link } from "react-router-dom";

const TILE_CONTENT = [
  {
    key: "financials",
    icon: Calculator,
    title: "Financials",
    body: "Run ABSD, BSD, mortgage, and affordability checks before you shortlist the next home.",
    cta: "Open Financials",
    href: "/financials",
  },
  {
    key: "market-insights",
    icon: Newspaper,
    title: "Market Insights",
    body: "Review district transaction signals, market commentary, and pricing context without leaving the portal.",
    cta: "Open Insights",
    href: "/insights",
  },
];

const surfaceClassMap = {
  dark: {
    shell: "mt-8 grid gap-4 lg:grid-cols-2",
    card: "rounded-[26px] border border-[#D4AF37]/26 bg-[linear-gradient(180deg,rgba(8,8,8,0.34),rgba(255,255,255,0.06))] px-5 py-5 shadow-[0_18px_45px_rgba(0,0,0,0.18)] backdrop-blur",
    label: "text-[#D4AF37]",
    title: "text-white",
    body: "text-[#F2ECE3]",
    cta: "text-[#F8D98A]",
    iconWrap: "border border-[#D4AF37]/22 bg-white/10 text-[#F8D98A]",
  },
  light: {
    shell: "mt-8 grid gap-4 lg:grid-cols-2",
    card: "rounded-[26px] border border-[#D7C39A]/36 bg-white/72 px-5 py-5 shadow-[0_18px_45px_rgba(12,40,90,0.08)] backdrop-blur",
    label: "text-[#8b6d16]",
    title: "text-[#0C285A]",
    body: "text-[#42566f]",
    cta: "text-[#0C285A]",
    iconWrap: "border border-[#D7C39A]/30 bg-[#FFF4DB] text-[#8b6d16]",
  },
};

export const AgentPortalHeroDiscoveryTiles = ({ buildBrandedPath, surface = "dark", testIdPrefix = "agent-portal-hero-discovery" }) => {
  const palette = surfaceClassMap[surface] || surfaceClassMap.dark;

  return (
    <div className={palette.shell} data-testid={`${testIdPrefix}-grid`}>
      {TILE_CONTENT.map((tile) => {
        const Icon = tile.icon;
        return (
          <Link className={`${palette.card} transition hover:-translate-y-1 hover:border-[#D4AF37]/42`} data-testid={`${testIdPrefix}-${tile.key}-card`} key={tile.key} to={buildBrandedPath(tile.href)}>
            <div className={`flex h-12 w-12 items-center justify-center rounded-full ${palette.iconWrap}`} data-testid={`${testIdPrefix}-${tile.key}-icon`}>
              <Icon className="h-5 w-5" />
            </div>
            <p className={`mt-4 text-[11px] font-bold uppercase tracking-[0.18em] ${palette.label}`} data-testid={`${testIdPrefix}-${tile.key}-label`}>
              Discover next
            </p>
            <h3 className={`mt-3 text-2xl font-semibold ${palette.title}`} data-testid={`${testIdPrefix}-${tile.key}-title`}>
              {tile.title}
            </h3>
            <p className={`mt-3 text-sm leading-7 ${palette.body}`} data-testid={`${testIdPrefix}-${tile.key}-body`}>
              {tile.body}
            </p>
            <span className={`mt-5 inline-flex items-center text-sm font-semibold ${palette.cta}`} data-testid={`${testIdPrefix}-${tile.key}-cta`}>
              {tile.cta} <ArrowRight className="ml-2 h-4 w-4" />
            </span>
          </Link>
        );
      })}
    </div>
  );
};